import { Link } from 'react-router-dom';
import { featuredArticles, articleCategories } from '@/mocks/home';

export default function ArticlesSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between mb-14 gap-6">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3 font-heading">
              精选文章
            </h2>
            <p className="text-foreground-600 max-w-lg leading-relaxed">
              来自社群的真实声音与深度思考，让每一篇文章都成为你成长路上的陪伴
            </p>
          </div>
          <Link
            to="/category/dating-tips"
            className="flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
                  {article.categoryName}
                </span>
                <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors font-heading">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 mb-4 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span>{article.author}</span>
                  <span>·</span>
                  <span>{article.date}</span>
                  <span>·</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {articleCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 text-foreground-700 text-sm font-medium hover:bg-primary-100 hover:text-primary-700 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className={`${cat.icon} text-base`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}